import { ButtonProps, Button as ChakraButton } from '@chakra-ui/react';
import { PropsWithChildren } from 'react';

export function Button({ children, ...props }: PropsWithChildren & ButtonProps) {
  return (
    <ChakraButton
      fontSize={'18px'}
      borderRadius={'100px'}
      fontWeight={500}
      minHeight={'60px'}
      backgroundColor="primaryColor"
      color="white"
      width={'100%'}
      iconSpacing={5}
      _hover={{ backgroundColor: 'primaryColor' }}
      {...props}
    >
      {children}
    </ChakraButton>
  );
}
